import React from 'react';
import { Navigate } from 'react-router';

import { pharmaciesRoutes } from './pharmaciesRoutes';
import { withPrivateRoute } from '../../withPrivateRoute';
import { allowedUserType, USER_TYPES } from '../../../../utils/constants';

const PharmacyOrderPage = React.lazy(
  () => import('../../../../features/pharmacyDirectory/pages/PharmacyOrderPage.tsx'),
);

const PharmacyOrderDetailsPage = React.lazy(() =>
  import('../../../../features/pharmacyDirectory/pages').then((module) => ({
    default: module.PharmacyOrderDetailsPage,
  })),
);

const PharmacyOrderQuickLink = React.lazy(() =>
  import('../../../../features/pharmacyDirectory/pages/PharmacyOrderQuickLink.tsx').then((module) => ({
    default: module.PharmacyOrderQuickLink,
  })),
);

/**
 * @satisfies {ExtendedRouteObject[]}
 */
export const pharmaciesRoutesWithLegacyRoute = [
  pharmaciesRoutes,
  {
    // This is a legacy route for the pharmacy directory - used to be /pharmacy-directory
    name: 'Pharmacy Directory',
    path: 'pharmacy-directory',
    type: 'item',
    element: <Navigate replace to="/pharmacies" />,
  },
  {
    name: 'Pharmacy Orders',
    path: 'orders',
    type: 'parent',
    ...withPrivateRoute(<PharmacyOrderPage />, {
      userCanAccess: ({ userType }) => allowedUserType([USER_TYPES.PHARMACIST], userType),
    }),
    children: [
      {
        name: 'Pharmacy Order Details',
        path: ':orderId',
        type: 'item',
        element: <PharmacyOrderDetailsPage />,
      },
    ],
  },
  {
    ...withPrivateRoute(<PharmacyOrderQuickLink />, {
      userCanAccess: ({ userType }) =>
        allowedUserType(
          [USER_TYPES.DIRECTOR, USER_TYPES.DOCTOR, USER_TYPES.NURSE, USER_TYPES.PHARMACIST, USER_TYPES.SUPPORT],
          userType,
        ),
    }),
    name: 'Pharmacy Order Quick Link',
    path: 'orders/ql/:quickLinkId',
    type: 'item',
  },
];
